module.exports = __webpack_public_path__ + "static/media/26.d6abe901.JPG";